import React, { Component } from 'react'
import { Resets, } from '../../components'
import firebase from 'firebase'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as resetsActionCreators from '../../redux/modules/resets'
import { db } from '../../config/firebaseconfig'

class ResetsContainer extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const resetId = this.props.match.params.resetId
    this.props.fetchingReset()
    db.collection('passwordResets').doc(resetId).get()
      .then((doc) => {
        if (doc.exists) {
          const reset = doc.data()
          this.props.fetchingResetSuccess(reset)
          this.props.fetchingIsStudent()
          return db.collection('students').doc(reset.userId).get()
        } else {
          this.props.fetchingResetError('Reset code not found.')
          return Error('Reset code not found.')
        }
      })
      .then((studentDoc) => {
        if (studentDoc.exists) {
          return this.props.fetchingIsStudentSuccess(true)
        } else {
          return this.props.fetchingIsStudentSuccess(false)
        }
      })
      .catch((err) => this.props.fetchingResetError(err))
  }

  render() {
    return (
      <Resets 
        isSaving={this.props.isSaving}
        isSavingError={this.props.isSavingError}
        isFetchingReset={this.props.isFetchingReset}
        isFetchingResetError={this.props.isFetchignResetError}
        reset={this.props.reset}
        isStudent={this.props.isStudent}
        isFetchingIsStudent={this.props.isFetchingIsStudent}
        saving={this.props.saving}
        savingSuccess={this.props.savingSuccess}
        savingError={this.props.savingError}
        history={this.props.history}
      />
    )
  }
}

export default connect(
  (state) => ({
    isSaving: state.resets.isSaving,
    isSavingError: state.resets.isSavingError,
    isFetchingReset: state.resets.isFetchingReset,
    isFetchingResetError: state.resets.isFetchingResetError,
    reset: state.resets.reset,
    isStudent: state.resets.isStudent,
    isFetchingIsStudent: state.resets.isFetchingIsStudent,
    isFetchingIsStudentError: state.resets.isFetchingIsStudentError,
    isFetchingIsStudentErrorContent: state.resets.isFetchingIsStudentErrorContent,
  }),
  (dispatch) => bindActionCreators(resetsActionCreators, dispatch)
)(ResetsContainer)


// WEBPACK FOOTER //
// ./src/containers/Users/ResetsContainer.js